"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChaveEncaixes = void 0;
var ChaveEncaixes = /** @class */ (function () {
    function ChaveEncaixes(_a) {
        var _b = _a._id, _id = _b === void 0 ? '' : _b, _c = _a.material, material = _c === void 0 ? '' : _c, _d = _a.chave, chave = _d === void 0 ? '' : _d, _e = _a.chaveEncaixe, chaveEncaixe = _e === void 0 ? '' : _e, _f = _a.descricao, descricao = _f === void 0 ? '' : _f;
        this._id = _id;
        this.material = material;
        this.chaveEncaixe = chaveEncaixe;
        this.chave = chave;
        this.descricao = descricao;
    }
    return ChaveEncaixes;
}());
exports.ChaveEncaixes = ChaveEncaixes;
//# sourceMappingURL=ChaveEncaixes.js.map